// extracted by mini-css-extract-plugin
var _1 = "#007ac9";
var _2 = "#575757";
var _3 = "exclamationMark-mBkV";
var _4 = "1.5rem";
var _5 = "header-vghP";
var _6 = "#dedede";
var _7 = "#adf";
var _8 = "1rem";
var _9 = "#bebebe";
var _a = ".8rem";
var _b = "unmeasuredStopGapPrompt-lFdw";
var _c = "#000";
export { _1 as "busBlue", _2 as "darkGrey", _3 as "exclamationMark", _4 as "extraLargeFontSize", _5 as "header", _6 as "lightGrey", _7 as "lightblue", _8 as "mediumFontSize", _9 as "mediumLightGrey", _a as "smallFontSize", _b as "unmeasuredStopGapPrompt", _c as "unusedNodeColor" }
